import create from './http';

const service = create({ baseURL: '//newiade.1sapp.com' });

export default service;
